export default __webpack_public_path__ + "images/Institute for Entrepreneurship.jpeg";